RCDPW.module('RCDPW.validator.rules.subscribe', {
    email: {
        required: true,
        customEmailWithBackList: true
    }
});